/*****
 * Created with WebStorm.
 * Date : 2019/5/31.
 * Author : Ztr.
 * Func : ...
 * note : 通用
 ******/
import $https from '@/utils/https'

// 登录接口
// export function login (params) {
//   return $https({
//     url: 'api/login',
//     method: 'POST',
//     serviceId: 'api.login',
//     params: params
//   })
// }



// WEBPACK FOOTER //
// ./src/services/modules/common.js